import type { ReactNode } from "react";
import type { DataGridRowProviderProps } from "@design-system/DataGrid";
import { SubScopeProvider } from "@state/subScopeContext";
import { NEW_TASK_PLACEHOLDER_WORKSPACE_ID } from "../taskListConstants";
import type { NestedTaskRow } from "../types";

const TaskWorkspaceScope = ({
    workspaceId,
    children,
}: {
    workspaceId: string;
    children: ReactNode;
}) => <SubScopeProvider value={{ workspaceId }}>{children}</SubScopeProvider>;

/**
 * The task list's `rowProvider` on organization-wide lists: a task row's
 * cells and editors read that task's workspace, so pickers load its data.
 * Group and placeholder rows keep the page's scope.
 */
export const TaskRowScope = ({
    row,
    children,
}: DataGridRowProviderProps<NestedTaskRow>) => {
    const { isGroup, workspaceId } = row;
    if (
        isGroup ||
        !workspaceId ||
        workspaceId === NEW_TASK_PLACEHOLDER_WORKSPACE_ID
    ) {
        return children;
    }
    return (
        <TaskWorkspaceScope workspaceId={workspaceId}>
            {children}
        </TaskWorkspaceScope>
    );
};
